import { ContextMenu as ContextMenuPrimitive } from "@base-ui/react/context-menu"
import type { ComponentProps } from "react"
import { cn } from "~/lib/utils"

const ContextMenu = ContextMenuPrimitive.Root
const ContextMenuTrigger = ContextMenuPrimitive.Trigger

function ContextMenuContent({
	className,
	anchor,
	...props
}: ComponentProps<typeof ContextMenuPrimitive.Popup> &
	Pick<ComponentProps<typeof ContextMenuPrimitive.Positioner>, "anchor">) {
	return (
		<ContextMenuPrimitive.Portal>
			<ContextMenuPrimitive.Positioner
				anchor={anchor}
				className="isolate z-50 outline-none"
				side="right"
				align="start"
				alignOffset={4}
			>
				<ContextMenuPrimitive.Popup
					data-slot="context-menu-content"
					className={cn(
						"surface-floating bg-popover text-popover-foreground max-h-(--available-height) min-w-56 origin-(--transform-origin) overflow-x-hidden overflow-y-auto rounded-lg p-1 outline-none data-starting-style:opacity-0 data-ending-style:opacity-0",
						className
					)}
					{...props}
				/>
			</ContextMenuPrimitive.Positioner>
		</ContextMenuPrimitive.Portal>
	)
}

function ContextMenuItem({
	className,
	...props
}: ComponentProps<typeof ContextMenuPrimitive.Item>) {
	return (
		<ContextMenuPrimitive.Item
			data-slot="context-menu-item"
			className={cn(
				"relative flex cursor-default items-center gap-2 rounded-sm px-2 py-2 text-sm outline-none select-none data-highlighted:bg-active data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 [&_svg]:text-muted-foreground",
				className
			)}
			{...props}
		/>
	)
}

function ContextMenuSeparator(
	props: ComponentProps<typeof ContextMenuPrimitive.Separator>
) {
	return (
		<ContextMenuPrimitive.Separator
			data-slot="context-menu-separator"
			className="my-1 h-px bg-border"
			{...props}
		/>
	)
}

export {
	ContextMenu,
	ContextMenuTrigger,
	ContextMenuContent,
	ContextMenuItem,
	ContextMenuSeparator
}
